export function isAsyncFunction(fn: Function): boolean {
    return fn.constructor.name === 'AsyncFunction';
}

// could make this into a hook and use nscompany from context so that nscompany.domains doesnt have to be passed in everywhere, since that's what this is being used for at the moment
export function emailDomainFoundInDomainList(fullEmailAddress: string, emailDomains: string[]): boolean {
    const lowercaseDomains = emailDomains?.map(dom => dom.toLowerCase());
    const emailDomain = fullEmailAddress.toLowerCase().split('@')[1];
    return lowercaseDomains?.includes(emailDomain);
}